import React, { useState } from "react";
import shortid from "shortid";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";

const ProfileResume = ({}) => {
	const classes = useStyles("Profile");

	return (
		<React.Fragment>
			<>
				<a className="anchor" id="resume" />

				<div className={classes.profileDivider}>
					<Divider light={true} />
				</div>

				<h2 className={classes.profileH2}>Resume</h2>

				<Box my={6}>
					<Grid container spacing={6}>
						<Grid item xs={12} md={6}>
							<div className={classes.profileResumeBorder}>
								<Box component="h3" className={classes.profileResumeH3}>
									Work Experience
								</Box>
								<Grid container spacing={10}>
									<Grid item xs={12}>
										<div className={classes.profileResumeTitle}>
											Partner & Attorney
										</div>
										<div className={classes.profileResumeDetail}>
											Minton, Burton, Bassett & Collins, P.C.
										</div>
										<div className={classes.profileResumeDetail}>
											2011 – Present
										</div>
									</Grid>
									<Grid item xs={12}>
										<div className={classes.profileResumeTitle}>
											Partner & Attorney
										</div>
										<div className={classes.profileResumeDetail}>
											Minton, Burton, Bassett & Collins, P.C.
										</div>
										<div className={classes.profileResumeDetail}>
											2011 – Present
										</div>
									</Grid>
								</Grid>
							</div>
						</Grid>
						<Grid item xs={12} md={6}>
							<div className={classes.profileResumeBorder}>
								<Box component="h3" className={classes.profileResumeH3}>
									Education
								</Box>
								<Grid container spacing={10}>
									<Grid item xs={12}>
										<div className={classes.profileResumeTitle}>
											The University of Texas School of Law
										</div>
										<div className={classes.profileResumeDetail}>JD</div>
										<div className={classes.profileResumeDetail}>2007</div>
									</Grid>
									<Grid item xs={12}>
										<div className={classes.profileResumeTitle}>
											The University of Texas
										</div>
										<div className={classes.profileResumeDetail}>
											B.B.A. (Bachelor of Business Administration)
										</div>
										<div className={classes.profileResumeDetail}>2004</div>
									</Grid>
								</Grid>
							</div>
						</Grid>

						<Grid item xs={12} md={6}>
							<div className={classes.profileResumeBorder}>
								<Box component="h3" className={classes.profileResumeH3}>
									Associations & Affiliations
								</Box>
								<Grid container spacing={10}>
									<Grid item xs={12}>
										<div className={classes.profileResumeTitle}>
											Texas Criminal Defense Lawyers Association
										</div>
										<div className={classes.profileResumeDetail}>
											Board Member
										</div>
										<div className={classes.profileResumeDetail}>
											2011 – Present
										</div>
									</Grid>
									<Grid item xs={12}>
										<div className={classes.profileResumeTitle}>
											Texas Criminal Defense Lawyers Association
										</div>
										<div className={classes.profileResumeDetail}>
											Board Member
										</div>
										<div className={classes.profileResumeDetail}>
											2011 – Present
										</div>
									</Grid>
								</Grid>
							</div>
						</Grid>

						<Grid item xs={12} md={6}>
							<div className={classes.profileResumeBorder}>
								<Box component="h3" className={classes.profileResumeH3}>
									Honors & Awards
								</Box>
								<Grid container spacing={10}>
									<Grid item xs={12}>
										<div className={classes.profileResumeTitle}>
											Super Lawyer
										</div>
										<div className={classes.profileResumeDetail}>
											Super Lawyers
										</div>
										<div className={classes.profileResumeDetail}>2023</div>
									</Grid>
									<Grid item xs={12}>
										<div className={classes.profileResumeTitle}>
											Top Austin Attorney
										</div>
										<div className={classes.profileResumeDetail}>
											Austin Monthly Magazine
										</div>
										<div className={classes.profileResumeDetail}>2023</div>
									</Grid>
								</Grid>
							</div>
						</Grid>

						<Grid item xs={12} md={6}>
							<div className={classes.profileResumeBorder}>
								<Box component="h3" className={classes.profileResumeH3}>
									Publications
								</Box>
								<Grid container spacing={10}>
									<Grid item xs={12}>
										<div className={classes.profileResumeTitle}>
											The Voice for the Defense
										</div>
										<div className={classes.profileResumeDetail}>
											<Link
												href="https://www.voiceforthedefenseonline.com/working-with-diverse-juries/"
												target="_blank"
												color="primary"
											>
												Working with Diverse Juries
											</Link>
										</div>
										<div className={classes.profileResumeDetail}>2021</div>
									</Grid>
								</Grid>
							</div>
						</Grid>

						<Grid item xs={12} md={6}>
							<div className={classes.profileResumeBorder}>
								<Box component="h3" className={classes.profileResumeH3}>
									Speaking Engagements
								</Box>
								<Grid container spacing={10}>
									<Grid item xs={12}>
										<div className={classes.profileResumeTitle}>
											Annual Ethics Conference
										</div>
										<div className={classes.profileResumeDetail}>
											<Link
												href="https://www.voiceforthedefenseonline.com/working-with-diverse-juries/"
												target="_blank"
												color="primary"
											>
												Representing Co-Defendants Ethically
											</Link>
										</div>
										<div className={classes.profileResumeDetail}>2023</div>
									</Grid>
								</Grid>
							</div>
						</Grid>
					</Grid>
				</Box>
			</>
		</React.Fragment>
	);
};

ProfileResume.propTypes = {};

export default ProfileResume;
